import Cnn from '../images/channels/cnn.png'
import Espn from '../images/channels/espn.png'
import Bbc from '../images/channels/bbc.png'
import HistoryCh from '../images/channels/history.jpg'
/*
import Discovery from '../images/channels/discovery.png'
import Fox from '../images/channels/fox.jpg'
import Abc from '../images/channels/abc.jpg'
import Ci from '../images/channels/ci.png'
import Lifestyle from '../images/channels/lifestyle.png'
import Disney from '../images/channels/disney.png'
import Nick from '../images/channels/nick.png'
import Mtv from '../images/channels/mtv.png'
*/
import blade from '../images/movies-vod/blade-runner.png';
import conjuring from '../images/movies-vod/conjuring.jpg';
import homecoming from '../images/movies-vod/homecoming.jpg';
import infinity from '../images/movies-vod/infinity-war.png';
import jumanji from '../images/movies-vod/jumanji-2017.png';
import lego from '../images/movies-vod/lego-batman.jpg';
import pacrim2 from '../images/movies-vod/pacrim2.jpg';
import wopota from '../images/movies-vod/wopota.jpg';
import axios from 'axios';

import musicIcon from '../images/link-icons/music-icon.svg'
import activityIcon from '../images/link-icons/activities-icon.svg'
import channelIcon from '../images/link-icons/channel-icon.svg'
import controlIcon from '../images/link-icons/control-icon.svg'
import movieIcon from '../images/link-icons/movies-icon.svg'
import vodIcon from '../images/link-icons/vod-icon.svg'
import errorImage from '../images/link-icons/icon4-error.png'
import hCommerce from '../images/icon/hcommerce.svg'
import guestRequests from '../images/icon/guestRequest.svg'
import spa from '../images/icon/spa.svg'
import viewBill from '../images/icon/viewBill.svg'
import hotelInfo from '../images/icon/hotelInfo.svg'
import tvControl from '../images/icon/tvLogo.svg'
//laguage files
import arText from '../app-text-files/arText.json'
import enText from '../app-text-files/enText.json'
import { app_connector_IP } from './config';
// import CryptoJS from 'crypto-js'

let layoutId = localStorage.getItem("LayoutMaster");
export const LayoutMaster = "webapp-type2" //!layoutId || layoutId === "null" ? "webapp-type2" : layoutId 
// export const LayoutMaster = layoutId && layoutId !== null ?
//   layoutId === "webapp-type2" ? "webapp-type2" : "webapp-type1"
//   : "webapp-type1"4567890-=\ 
export const globalIV = "a7eda6dc9e3305b593a98ab7947cd254"
//CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
export const globalSalt = "2e6d3cbbc2f0351fcca7172e43cf918c"
//CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);

export const token = //"d3a93360-7904-46dc-8316-d5d3fc348a20"
  "8f67428d-3925-49bc-b9a5-756e2381ff17"
export const buttonFontColor = "#fff"
//govind "e8ebc2c0-43e0-4f62-bb14-4bc0525c1140 "daigo "9c2b451e-cf04-446a-b49d-e7c2e984230a"
export const protocol= process.env.REACT_APP_API_PROTOCOL
export const defultIP = process.env.REACT_APP_SERVER_IP

export const CMSPath_Master = (defultIP.startsWith("http") || defultIP.startsWith("https")) ? `${defultIP}` : protocol == 'http' ? `http://${defultIP}:8080` : `https://${defultIP}:8443`;

export const CMSPath = (app_connector_IP.startsWith("http") || app_connector_IP.startsWith("https")) ? `${app_connector_IP}` : protocol == 'http' ? `http://${app_connector_IP}:8080` : `https://${app_connector_IP}:8443`

export const CMSPath_HTTP = app_connector_IP.startsWith("https") ? app_connector_IP.replace("https", "http").replace(":8443", ":8080") : app_connector_IP.startsWith("http") ? app_connector_IP : `http://${app_connector_IP}:8080`;

export const CMSPath_HTTPS = app_connector_IP.startsWith("https") ? app_connector_IP : app_connector_IP.startsWith("http") ? app_connector_IP.replace("http", "https").replace(":8080", ":8443") : `https://${app_connector_IP}:8443`;

export const DEV_IP = "90.231.196.86"

export const instagramRedirectUrl = "http://localhost:3000&"
export const instagramClientID = "e45c8dd075754e8dba20c32df1bd25cb"
export const errorMsg = "You must be in hotel room to use this feature."
export const deviceNameErrorMsg = "Invalid Device name."
export const IPAddressErrorMsg = "Invalid IP Address."
export const serviceFailureMsg = 'No reply from server.'
export const zoneName = "zone1"
export const commanEventListerKey = 'homepageevenlistner';
export const ENABLEDIGITALKEY= process.env.REACT_APP_ENABLEDIGITALKEY == 'true';
export const SHOW_ALLERGY_OPTIONS = process.env.REACT_APP_SHOW_ALLERGY_OPTIONS == 'true';
export const HIDE_NUMBER_OF_DAYS = process.env.REACT_APP_HIDE_CHECKOUT_DAYS == "true"
export const ENABLESTICKYHEADER = process.env.REACT_APP_ENABLESTICKYHEADER == 'true'
export const MAP_ENABLED=process.env.REACT_APP_MAP_ENABLED == 'true'
export const DEBUG=process.env.REACT_APP_DEBUG == 'true'
export const ZINGLE_DEMO = process.env.REACT_APP_ZINGLE_DEMO == 'true'
export const ZINGLE_ANDROIDID = process.env.REACT_APP_ZINGLE_ANDROIDID
export const ZINGLE_IOSID = process.env.REACT_APP_ZINGLE_IOSID
export const CARD_AUTHORIZED_FOR_DEPOSIT = process.env.REACT_APP_CARD_AUTHORIZED_FOR_DEPOSIT == "true"
export const QRSCANENABLE=process.env.REACT_APP_QRSCANENABLE == 'true'
export const DEVICEREGFORMENABLED = process.env.REACT_APP_INROOMTAB == "true" ? true : process.env.REACT_APP_ENABLE_DEVICE_REGISTRATION == "true"
export const CHECKINENABLED = process.env.REACT_APP_CHECKINENABLED == 'true'
export const CRASHLYTICSCOLLECTION = process.env.REACT_APP_CRASHLYTICSCOLLECTION == 'true'
export const ENABLELANGSELECTION = true
export const LOGINENABLED = process.env.REACT_APP_LOGINENABLED == 'true'
export const ENABLE_CREDIT_CARD_SCREEN = true;
export const PRIVACYPOLICY = "https://www.tamassaresorts.com/privacy-policy";//"https://www.doncesar.com/privacy-policy";
export const TERMSANDCONDITIONS = "https://www.doncesar.com/terms-of-use";
export const DEMO = process.env.REACT_APP_DEMO == 'true'
export const WITH_MASTER_CONNECTOR = process.env.REACT_APP_WITH_MASTER_CONNECTOR == "true"; 
export const HEADER_LOCATION_AFTER_LOGIN = process.env.REACT_APP_HEADER_LOCATION_AFTER_LOGIN == "true";
export const HEADER_LOCATION_REDIRECTS_TO_CORPS = process.env.REACT_APP_HEADER_LOCATION_REDIRECTS_TO_CORPS == "true";
export const INROOMTAB = process.env.REACT_APP_INROOMTAB == "true"
export const WEB_VERSION_ENABLED = process.env.REACT_APP_WEB_VERSION_ENABLED == "true"
export const IDCARD_DEMO = process.env.REACT_APP_IDCARD_DEMO == 'true'
export const CARD_DEMO = process.env.REACT_APP_CARD_DEMO == "true"
export const EMAIL_MANDATORY = process.env.REACT_APP_EMAIL_MANDATORY == "true"
export const PHONE_MANDATORY = process.env.REACT_APP_PHONE_MANDATORY == "true"
export const POSTAL_CODE_MANDATORY = process.env.REACT_APP_POSTAL_CODE_MANDATORY == "true"
export const ENABLE_US_DATE_FORMAT = process.env.REACT_APP_ENABLE_US_DATE_FORMAT == "true"
export const IS_BETA_BUILD = process.env.REACT_APP_IS_BETA_BUILD == "true";
export const DONT_CLEAR_INAPPBROWSER_CACHE = process.env.REACT_APP_DONT_CLEAR_INAPPBROWSER_CACHE == "true";
export const HIDE_INAPPBROWSER_NAVIGATION = process.env.REACT_APP_HIDE_INAPPBROWSER_NAVIGATION == "true";
export const USEOLDLOGOUT = false;
export const USEFRESHCHAT = true;
export const VERIFY_THROUGH_CMS = process.env.REACT_APP_VERIFY_THROUGH_CMS == 'true'
export const ENABLE_NEW_CHECKOUT_FLOW = true;
export const FRESHCHATTOKEN = "fd6684c4-3dfc-40fa-ad4a-06caa15d1405" //"4aa02b26-0466-402c-9c24-cfb83cc62c94";//"9d570922-9e0d-40e5-bdbc-2cc5ec639abe"//"7ac72758-f38d-415b-ad62-c10c76140643"//
export const FRESHCHATHOST = "https://wchat.in.freshchat.com";
export const ROOMCONTROLTYPE = 'Inncom'
export const LANDSCAPE_ON_TABLET = process.env.REACT_APP_LANDSCAPE_ON_TABLET == 'true'
export const PAYMENT_GATEWAY = "Elavon"
export const CARD_VALIDATION_ENABLED = process.env.REACT_APP_CARD_VALIDATION_ENABLED == 'true'
export const CARD_CAN_BE_CHARGED = false
export const HIDE_EMAIL_FIELD_ON_CHECKOUT = true
export const GOOGLE_CAPTCHA_KEY="6LeY6xIqAAAAAEeXCkFlq0dcUJxZVKitcl06Nzx-";
export const DONT_ASK_BOOKING_NUMBER_ON_PRECHECKIN_SUCCESS=process.env.REACT_APP_DONT_ASK_BOOKING_NUMBER_ON_PRECHECKIN_SUCCESS == 'true' ;
export const REACT_APP_EXTERNAL_SIGN_IN=process.env.REACT_APP_EXTERNAL_SIGN_IN == 'true';
export const HCOMMERCE_ADDONS_AS_NON_MANDATORY=process.env.REACT_APP_HCOMMERCE_ADDONS_AS_NON_MANDATORY == 'true';
export const REACT_APP_NEWER_DESIGN = process.env.REACT_APP_NEWER_DESIGN == 'true';
export const SHOW_GDPR_BEFORE_ID_AND_SELFIE_SCAN = process.env.REACT_APP_SHOW_GDPR_BEFORE_ID_AND_SELFIE_SCAN == 'true';
export const ENABLE_HOTEL_SELECTOR_QUICK_LINKS = process.env.REACT_APP_ENABLE_HOTEL_SELECTOR_QUICK_LINKS == 'true';
export const TEMP_SPA_WIDGET_ACT_AS_FIND_YOUR_STAY_NON_THE_KNOW_MEMBERS = process.env.REACT_APP_TEMP_SPA_WIDGET_ACT_AS_FIND_YOUR_STAY_NON_THE_KNOW_MEMBERS == 'true';
export const PROVIDE_INCREASE_DECREASE_ITEM_QUANTITY_ON_HCOM_CHECKOUT_PAGE = process.env.REACT_APP_PROVIDE_INCREASE_DECREASE_ITEM_QUANTITY_ON_HCOM_CHECKOUT_PAGE == 'true';
export const HCOM_NEWER_FLOW_SIMILAR_TO_TV = process.env.REACT_APP_HCOM_NEWER_FLOW_SIMILAR_TO_TV == 'true';
export const PREFER_ECP_OVER_UNIT_FROM_API_FOR_TEMPERATURE_UNIT = process.env.REACT_APP_PREFER_ECP_OVER_UNIT_FROM_API_FOR_TEMPERATURE_UNIT == 'true';
export const ALLOW_ONLY_WHITELISTED_URLS_FOR_IFRAME_RENDERER = process.env.REACT_APP_ALLOW_ONLY_WHITELISTED_URLS_FOR_IFRAME_RENDERER == 'true';
export const WHITELISTED_URLS_FOR_IFRAME_RENDERER = JSON.parse(process.env.REACT_APP_WHITELISTED_URLS_FOR_IFRAME_RENDERER || '[]');
export const ENABLE_DEVICE_CONFIG_CACHING = process.env.REACT_APP_ENABLE_DEVICE_CONFIG_CACHING == 'true';
export const ELAVON_UPDATED_FLOW = process.env.REACT_APP_ELAVON_UPDATED_FLOW == "true";

//extend stay id is a guest request id. so if still use this it will break.
export const extendStayServiceID = "4"
export const DONT_FORCE_TO_ENABLE_PERMISSION_WHILE_DOORKEY_BUT_JUST_WARN = process.env.REACT_APP_DONT_FORCE_TO_ENABLE_PERMISSION_WHILE_DOORKEY_BUT_JUST_WARN == 'true';



//VDA control action.
export const setLightSceneAction = "setLightCtrlScene" //Set particular Light Scene
export const setFanSpeedToLow = "setFanSpeedToLow"//Swich Fan Speed to Low
export const setFanSpeedToMedium = "setFanSpeedToMedium"//Swich Fan Speed to Medium
export const setFanSpeedToHigh = "setFanSpeedToHigh"//Swich Fan Speed to High
export const setFanSpeedToAuto = "setFanSpeedToAuto"//Swich Fan Speed to Auto
export const setFanSpeedToggle = "setFanSpeedToCircularToggle"//Swich Fan Speed to Toggle in a circular Manner
export const setTempOfAC = "setTempOfAC"//Set temperature of AC(HVAC) to particular degree Celcius Value
export const ACPower = "toggleAC"// to toggle AC main Switch (to switch AC on or Off)
export const ecoMode = "toggleACEcoMode"
export const setCurtain = "setCurtainCtrlScene"
export const dimCurtain = "dimCurtainCtrlScene"
export const unlockDoor = "unlockDoor"
export const decrementTemp = "decrementTemperature"
export const incrementTemp = "incrementTemperature"
export const makeUpRoomCall = "makeUpRoomCall"
export const doNotDisturbCall = "doNotDisturbCall"

// GA Events
export const CLICKED = "CLICKED"
export const DURATION = "DURATION"
export const LAUNCHED = "LAUNCHED"
export const EXIT = "EXIT"
export const RECEIVED = "RECEIVED"
export const CHANNELNAME = "CHANNELNAME"
export const LOAD_ERROR = "LOAD_ERROR"
export const APP_LAYOUT = "APP_LAYOUT"
// export const Duration = "Duration"

//speaker actions
export const infoAction = "getSpeakerInfo" // action to get speaker info 
export const speakerSetZoneAction = "setZone"
export const changeVolume = "changeSpeakerVolume"

//
export const gettingKeyMsg = "We are trying to get a Digital Key for your room, please be patient."
export const tapToUnlockMsg = "Your Digital Key is ACTIVE.\n Please tap your phone on the door lock in order to unlock it."
export const tapToUnlockMsgTenSec = "Your Digital Key is INACTIVE."
export const gettingKeySuccMsg = `Your Digital Key is set up successfully and it is ACTIVE.\n Please tap your phone on the door lock in order to unlock it.`
export const gettingKeySuccMsgTenSec = `Your Digital Key is INACTIVE.`
export const gettingKeyFailMsg = "We are not able to get a Digital Key for your room, please try again after some time."
export const bluetoothCheckMsg = "To unlock the door, Bluetooth must be enabled."
export const internetCheckMsg = "In order to unlock the door, you need to have active Internet connection."
export const successfulUnlock = "Door Unlocked Successfully."
//
export const languageFiles = {
  "ar": {
    langCode: "ar",
    file: arText
  },
  "en": {
    langCode: "en",
    file: enText
  }
}

export const fanSpeedID = [
  "FAN_SPEED_AUTO",
  "FAN_SPEED_LOW",
  "FAN_SPEED_MEDIUM",
  "FAN_SPEED_HIGH"

]

export const listCurtains = [
  {
    id: "curtain1",
    htmlId: "curtain1ON",
    name: "Open Curtains"
  },
  {
    id: "curtain1",
    htmlId: "curtain1OFF",
    name: "Close Curtains"
  },
  {
    id: "curtain2",
    htmlId: "curtain2ON",
    name: "Black out Curtains open."
  },
  {
    id: "curtain2",
    htmlId: "curtain2OFF",
    name: "Black out Curtains Close."
  }
]
export const lightSceneIds = [
  "lightScreen1",
  "lightScreen2",
  "lightScreen3",
  "lightScreen4",
  "lightScreen5",
  "lightScreen6",
  "lightScreen7",
  "lightScreen8"
]

export const lightSceneLabels = [
  {
    "light1": {
      id: "light1",
      label: "Master Bedroom"
    }
  },
  {
    "light2": {
      id: "light2",
      label: "Ambient"
    }
  },
  {
    "light3": {
      id: "light3",
      label: "Accent"
    }
  },
  {
    "light4": {
      id: "light4",
      label: "Master Bathroom"
    }
  },
  {
    "light5": {
      id: "light5",
      label: "Bathroom Ambient"
    }
  },
  {
    "light6": {
      id: "light6",
      label: "Feature Wall"
    }
  },
  {
    "light7": {
      id: "light7",
      label: "Master On/Off"
    }
  }
]

export const speakerList = [
  {
    id: "SOUND_BAR",
    name: "SOUND_BAR",
    bluetoothName: "Bose main speaker",
    currentSource: null,
    currentVolume: 50
  },
  {
    id: "BATHROOM_SPEAKER",
    name: "BATHROOM_SPEAKER",
    bluetoothName: "Bose RestRoom speaker.",
    currentSource: null,
    currentVolume: 50
  }
]

export const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
]

//this is to get months title from there number
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
]

export const movies = [
  {
    title: "blade",
    image: blade
  },
  {
    title: "conjuring",
    image: conjuring
  },
  {
    title: "homecoming",
    image: homecoming
  },
  {
    title: "jumanji",
    image: jumanji
  },
  {
    title: "infinity",
    image: infinity
  },
  {
    title: "lego",
    image: lego
  },
  {
    title: "pacrim2",
    image: pacrim2
  },
  {
    title: "wopota",
    image: wopota
  }
]

export default axios.create({
  baseURL: 'https://demo6697847.mockable.io'
})
// these are element of side menu with there classes and routing path 

export const compType = [
  {
    compName: "Listen to Music",
    alterNativeName: [
      "music",
      "listen"
    ],
    path: "/music",
    image: musicIcon
  },
  /*{
    alterNativeName: "ico4-rs.png",
    className: "room-servies",
    path: "/room-servies"
  },*/
  {
    compName: "Activities",
    alterNativeName: [
      "activities",
      "activity"
    ],
    path: "/activities",
    image: activityIcon
  },
  {
    compName: "Tv-Control",
    alterNativeName: [
      "tv control",
      "epg-iptv",
      "epg",
      "iptv"
    ],
    path: "/channels",
    image: tvControl
  },
  {
    compName: "Room Control",
    alterNativeName: [
      "room control",
      "control"
    ],
    path: "/RoomControl",
    image: controlIcon
  },
  {
    compName: "Movies",
    alterNativeName: [
      "movies",
      "movie"],
    path: "/movies",
    image: movieIcon
  },
  {
    compName: "Cheval Blanc VOD",
    alterNativeName: [
      "video on demand",
      "vod"
    ],
    path: "/vod",
    image: movieIcon
  },
  {
    compName: "Butler Services",
    alterNativeName: [
      "room-assistance"
    ],
    path: ""
  },
  {
    compName: "App Launcher",
    alterNativeName: [
      "applauncher",
      "launcher",
      "app launcher",
      "crestron",
      "room cantrol"
    ],
    path: "",
    image: controlIcon
  },
  {
    compName: "Url Renderer",
    alterNativeName: [
      "url renderer",
      "urlrenderer"
    ],
    path: "",
    image: errorImage
  },
  {
    compName: "Hotel Guide",
    alterNativeName: [
      "hotel guide",
      "hotelguide"
    ],
    path: "",
    image: hotelInfo
  },
  {
    compName: "Guest Requests",
    alterNativeName: [
      "guest request",
      "guest requests"
    ],
    path: "/guestRequests",
    image: guestRequests
  },
  {
    compName: "View My Bill",
    alterNativeName: [
      "view my bill",
      "view bill"
    ],
    path: "/viewBill",
    image: viewBill
  },
  {
    compName: "Spa",
    alterNativeName: [
      "spa widget",
      "spa"
    ],
    path: "/spa",
    image: spa
  },
  {
    compName: "Room service",
    alterNativeName: [
      "h-commerce",
      "hcommerce",

    ],
    path: "/Hcommerce",
    image: hCommerce
  },
  {
    compName: "Door Camera",
    alterNativeName: [
      "door camera feed",
      "camerastream",
      "camera"
    ],
    path: "",
    image: vodIcon
  }
  /*
  {
    alterNativeName: "icon4-error.png",
    path: "/error"
  },
  {
    alterNativeName: "ico4-rate.png",
    className: "rate",
    path: "/rate"
  }*/
]

export const pos = [
  {
    widgetName: "userInfo",
    position: "1"
  },
  {
    widgetName: "userActivity",
    position: "2"
  },
  {
    widgetName: "promo",
    position: "3"
  },
  {
    widgetName: "userShortcut",
    position: "4"
  },
]

export const controlElements = [
  {
    controlName: "Air Conditioning"
  },
  {
    controlName: "Light Controls"
  },
  {
    controlName: "Curtain Controls"
  },
  {
    controlName: "Door Controls"
  },
  {
    controlName: "Speaker Controls"
  }
]
export const activities = [
  {
    time: "13:00",
    name: "NO ACTIVITY",
    rating: 1,
    image: Cnn,
    url: "",
    description: "We don't have any activity for you right now. We will add it soon."
  }
]
export const activitiee = [
  {
    time: "13:00",
    name: "ALCHEMISTS",
    rating: 1,
    image: Cnn,
    url: "https://en.wikipedia.org/wiki/List_of_alchemists",
    description: "A team of Alchemists designs a wide array of tailor-made activities and unforgettable experiences for every guest."
  },
  {
    time: "13:00",
    name: "DIVING",
    rating: 3,
    image: Espn,
    url: "https://en.wikipedia.org/wiki/Diving",
    description: "The island of Randheli offers the perfect setting to discover or re-discover the unparalled beauty of the Maldivian sea."
  },
  {
    time: "13:00",
    name: "WATER ACTIVITIES",
    rating: 5,
    image: Bbc,
    url: "https://en.wikipedia.org/wiki/List_of_water_sports",
    description: "A fleet of traditional wooden dhonis and excursion boats invites guests to sail the waters of the atoll."
  },
  {
    time: "13:00",
    name: "SPORTS & FITNESS",
    rating: 5,
    image: HistoryCh,
    url: "https://www.twitch.tv/directory/game/Sports%20%26%20Fitness",
    description: "A fitness centre opening onto the horizon and two tennis courts sheltered by palm trees allow sport connoisseurs to train in a spectacular setting."
  },
  {
    time: "13:00",
    name: "SWIMMING",
    rating: 3,
    image: Espn,
    url: "https://en.wikipedia.org/wiki/Swimming_(sport)",
    description: "The island of Randheli offers the perfect setting to discover or re-discover the unparalled beauty of the Maldivian sea."
  }
]

export let signupActivitys = [
  /*{
    time: "13:00",
    name: "ALCHEMISTS",
    rating: 1,
    image: Cnn,
    description: "A team of Alchemists designs a wide array of tailor-made activities and unforgettable experiences for every guest."
  }*/
]

/*export const channels = [
  {
    channelId: 1,
    channelName: "CNN",
    channelImage: Cnn
  },
  {
    channelId: 2,
    channelName: "ESPN",
    channelImage: Espn
  },
  {
    channelId: 3,
    channelName: "BBC News",
    channelImage: Bbc
  },
  {
    channelId: 4,
    channelName: "History",
    channelImage: HistoryCh
  },
  {
    channelId: 5,
    channelName: "Discovery",
    channelImage: Discovery
  },
  {
    channelId: 6,
    channelName: "FOX",
    channelImage: Fox
  },
  {
    channelId: 7,
    channelName: "ABC",
    channelImage: Abc
  },
  {
    channelId: 8,
    channelName: "Crime Investigation",
    channelImage: Ci
  },
  {
    channelId: 9,
    channelName: "Lifestyle",
    channelImage: Lifestyle
  },
  {
    channelId: 10,
    channelName: "Disney",
    channelImage: Disney
  },
  {
    channelId: 11,
    channelName: "Nick",
    channelImage: Nick
  },
  {
    channelId: 12,
    channelName: "MTV",
    channelImage: Mtv
  }
] 

export const userAcivity = [
  {
    time: "13:00",
    activity: "Sea Excursions"
  },
  {
    time: "18:00",
    activity: "Sunset Drinks at the Beach"
  },
  {
    time: "20:00",
    activity: "Dinner at the White Bar"
  },
  {
    time: "13:00",
    activity: "Sea Excursions"
  },
  {
    time: "18:00",
    activity: "Sunset Drinks at the Beach"
  },
  {
    time: "13:00",
    activity: "Sea Excursions"
  },
  {
    time: "18:00",
    activity: "Sunset Drinks at the Beach"
  }
]

export const shortCutTitle = [
  {
    title: "Listen to music",
    path: "/music"
  },
  {
    title: "Watch Video-on-demand",
    path: "/music"
  },
  {
    title: "Hotel Movie list",
    path: "/music"
  },
  {
    title: "Order breakfast",
    path: "/music"
  },
  {
    title: "Plan Activities",
    path: "/music"
  }
]

*/
export const navElements = [
  {
    text: "Listen to Music",
    className: "listen",
    path: "/music",
    icon: musicIcon
  },/*
  {
    text: "ico4-rs.png",
    className: "room-servies",
    path: "/room-servies"
  },*/
  {
    text: "Activities",
    className: "activities",
    path: "/activities",
    icon: activityIcon
  },
  {
    text: "TV Control",
    className: "tv-ctl",
    path: "/channels",
    icon: channelIcon
  },
  {
    text: "Room Control",
    className: "room-ctl",
    path: "/RoomControl",
    icon: controlIcon
  },
  {
    text: "movies",
    className: "movies",
    path: "/movies",
    icon: movieIcon
  },
  {
    text: "Cheval Blanc VOD",
    className: "vod",
    path: "/vod",
    icon: vodIcon
  },
  {
    text: "Butler Services",
    className: "ico-svc",
    path: "/vod",
    icon: musicIcon
  }/*,
  {
    text: "icon4-error.png",
    className: "error",
    path: "/error"
  },
  {
    text: "ico4-rate.png",
    className: "rate",
    path: "/rate"
  }*/
]

export const dormakabaErrorCodes = {
  error_113: "All Keys: The key is not valid in the current lock mode or cycle. Lock is typically in an invalid mode. This code may also appear if you use standard or display keys when the PPK or SPK LEDs are flashing.",
  error_117: "Standard, Special, PPK and SPK Keys: The lock is in shutdown cycle because 10 or more invalid keys were used. A valid key must be used to terminate shutdown mode.",
  error_122: "Standard Keys: Lock level is non-operating for this key’s type. The key does not belong to this lock.",
  error_123: "Standard and Special Keys: Key is not mastered into the lock. The key does not belong to this lock.",
  error_127: "Standard Keys: Key does not have one of the 12 valid pass numbers required for the pass level.",
  error_128: "Standard and Special Keys: Key is an old key; its new key date is earlier than the lock’s key data. Replace the key with a current or new key.",
  error_129: "Standard and Special Keys: Key is an old key; its new key time is earlier than the lock’s key data. Replace the key with a current or new key.",
  error_134: "Standard and Special Keys: Key is an old key, level has limited sequence range (1-15) but key’s sequence number is older than the lock’s key data. Replace key with a current or new key. Use a re-sequence key if necessary.",
  error_135: "Standard and Special Keys: Key is too new, level has limited sequence range and key’s sequence number is beyond the lock’s key data and range. Make and use a re-sequence key, then try the original key again.",
  error_136: "Standard Key: Key is a limited use key and has already been used the maximum number of times. Replace key with a new key.",
  error_137: "Standard Key: The key is a new key but the door is dead bolted and the new key cannot be accepted. If key is for a new guest, the room is still occupied. Assign new guest to another room.",
  error_141: "All Keys: The key is expired based on the lock’s clock date and time. Replace key with a duplicate key with a later expiration date and time.",
  error_149: "Standard Key: Key is current but key’s level is inhibited. Replace key with a new key.",
  error_150: "Special Key: Key is current but key is inhibited. Replace key with a new key.",
  error_152: "Standard Key: Key’s level is electronically locked out. If this key is a dual, electronic lock/unlock, inhibit level, or unlatch/latch key; it will not perform its function. The electronic unlock key must be used to remove the electronic lockout.",
  error_154: "Standard Key: Key is an opening key, but the lock is dead bolted and the key cannot override it.",
  error_178: "Standard Key: The key is new and is identified as a pre-reg key which will not work until its check-in date and time. If desired, replace key with a new key.",
  error_255: "Generic Error"
}


export const assaAbloyErrorCodes = {
  GuestCardOverridden: "Key is overridden",
  GuestCardOverridden_v2: "Key is overridden",
  CardNotValidYet: "Key is not valid yet",
  CardHasExpired: "Key has expired",
  CardCancelled: "Key is cancelled",
  CardUsergroupBlocked: "Key group is blocked",
  NoAccessToThisRoom: "Key has no access to this room",
  WrongSystemNumberOnCard: "Key has no access to this hotel",
  NotValidAtThisTime: "Key not valid at this time of day",
  CardOnlyValidDuringOpeningTime: "Key not valid at this time of day",
  DoorUnitDeadBolted: "Key blocked because of deadbolt",
  DoorUnitDeadBoltedGuest: "Key blocked because of deadbolt",
  DoorUnitDeadBoltedFamily: "Key blocked because of deadbolt",
  NotValidDueToPrivacyStatus: "Key blocked because of room privacy settings",
  NotValidDueToPrivacyStatusSilt: "Key blocked because of room privacy settings",
  NotValidDutToDoNotDisturbStatus: "Key blocked because of room privacy settings",
  AccessDeniedDueToBatteryAlarm: "Key blocked because of door battery level",
  NotValidDueToAntiPassback: "Key blocked by anti passback function",
  NotValidDueToDoorNotClosed: "Key refused because door is not locked",
  NotValidDueToOpenStatus: "Key refused because door is not locked",
  WrongPIN: "Key refused due to PIN code",
  WrongPIN_v2: "Key refused due to PIN code",
  CommandNotValidForThisLock: "Key blocked by access rules",
  CounterValueTooLow: "Key blocked by access rules",
  NotValidDueToPassageRevoked: "Key blocked by access rules",
  NotApplicable: "No case matched"
}


export const assaAbloyErrorCodesForiOS = {
  16: "Key is overridden",
  17: "Key is overridden",
  18: "Key is not valid yet",
  322: "Key has expired",
  23: "Key is cancelled",
  24: "Key group is blocked",
  320: "Key has no access to this room",
  261: "Key has no access to this hotel",
  22: "Key not valid at this time of day",
  32: "Key not valid at this time of day",
  33: "Key blocked because of deadbolt",
  34: "Key blocked because of deadbolt",
  35: "Key blocked because of deadbolt",
  38: "Key blocked because of room privacy settings",
  39: "Key blocked because of room privacy settings",
  43: "Key blocked because of room privacy settings",
  53: "Key blocked because of door battery level",
  21: "Key blocked by anti passback function",
  36: "Key refused because door is not locked",
  37: "Key refused because door is not locked",
  19: "Key refused due to PIN code",
  25: "Key refused due to PIN code",
  26: "Key blocked by access rules",
  20: "Key blocked by access rules",
  40: "Key blocked by access rules",
}

export const TVChannelsProgressBarRerenderTime = 60000
export const errorCodeOtpValidationForLogin=["OTP", "OTP_INVALID","OTP_MISMATCH", "OTP_EXPIRED" ];

export const mapOtpFaliureCodeToMessage = {
  OTP_EXPIRED: "Your one-time passcode got expired. Sending a new one...",
  OTP_MISMATCH: "Your one-time passcode does not match",
  OTP_INVALID: "Your one-time passcode is not valid"
}


export const Shift4AvsResultReasons = {
    'A': 'Street address matched, but ZIP/postal code did not match.',
    'E': 'Error - AVS data is invalid or not allowed.',
    'N': 'No street address and no ZIP/postal code match.',
    'R': 'Card issuer system is unavailable.',
    'S': 'AVS service not supported.',
    'U': 'Street address information unavailable.',
    'X': 'Street address and 9-digit ZIP/postal code matched.',
    'Y': 'Street address and 5-digit ZIP code matched.',
    'Z': 'Only the ZIP/postal code matched.'
};
